import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import SvgIcon from './SvgIcon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var AssignToOtherIcon = function AssignToOtherIcon(props) {
  return /*#__PURE__*/_jsx(SvgIcon, _objectSpread(_objectSpread({
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("g", {
      id: "AssignToOtherIcon",
      "data-name": "AssignToOtherIcon",
      children: /*#__PURE__*/_jsxs("g", {
        id: "Group_Icon",
        "data-name": "Group Icon",
        children: [/*#__PURE__*/_jsx("polygon", {
          id: "BoundingBox",
          points: "0 0 18 0 18 18 0 18",
          fill: "none"
        }), /*#__PURE__*/_jsx("path", {
          id: "User",
          fill: "currentColor",
          d: "M6.75,9 C8.4075,9 9.75,7.6575 9.75,6 C9.75,4.3425 8.4075,3 6.75,3 C5.0925,3 3.75,4.3425 3.75,6 C3.75,7.6575 5.0925,9 6.75,9 Z M6.75,10.5 C4.7475,10.5 0.75,11.505 0.75,13.5 L0.75,15 L12.75,15 L12.75,13.5 C12.75,11.505 8.7525,10.5 6.75,10.5 Z"
        }), /*#__PURE__*/_jsx("polygon", {
          id: "Arrow",
          fill: "currentColor",
          transform: "translate(14.25, 8.25) rotate(-180) translate(-14.25, -8.25)",
          points: "17.25 7.875 12.68625 7.875 14.7825 5.77875 14.25 5.25 11.25 8.25 14.25 11.25 14.77875 10.72125 12.68625 8.625 17.25 8.625"
        })]
      })
    })
  }));
};
export default AssignToOtherIcon;